import { TypesDocumentIds } from '@pages/employees/constants/Employees';

export const documentTypesById = {
    [TypesDocumentIds.CC]: 'CC',
    [TypesDocumentIds.CE]: 'CE',
    [TypesDocumentIds.NIT]: 'NIT',
    [TypesDocumentIds.TI]: 'TI',
    [TypesDocumentIds.RC]: 'RC',
    [TypesDocumentIds.PA]: 'PA',
    [TypesDocumentIds.CD]: 'CD',
    [TypesDocumentIds.SC]: 'SC',
    [TypesDocumentIds.PE]: 'PE',
    [TypesDocumentIds.PT]: 'PT',
    [TypesDocumentIds.PC]: 'PC',
};
